"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyOperationReturnType = exports.OperationReturnType = exports.ReturnTypes = void 0;
const ResponseHelper_js_1 = require("./ResponseHelper.js");
var ReturnTypes = /*#__PURE__*/function (ReturnTypes) {
  ReturnTypes[ReturnTypes["VOID"] = 0] = "VOID";
  ReturnTypes[ReturnTypes["VALUE"] = 1] = "VALUE";
  ReturnTypes[ReturnTypes["VALUE_COLLECTION"] = 2] = "VALUE_COLLECTION";
  ReturnTypes[ReturnTypes["COMPLEX"] = 3] = "COMPLEX";
  ReturnTypes[ReturnTypes["COMPLEX_COLLECTION"] = 4] = "COMPLEX_COLLECTION";
  return ReturnTypes;
}(ReturnTypes || (exports.ReturnTypes = ReturnTypes = {}));
function getResponseConverter(returnType) {
  switch (returnType) {
    case ReturnTypes.VALUE:
      return ResponseHelper_js_1.convertV4ValueResponse;
    case ReturnTypes.COMPLEX:
      return ResponseHelper_js_1.convertV4ModelResponse;
    case ReturnTypes.VALUE_COLLECTION:
    case ReturnTypes.COMPLEX_COLLECTION:
      return ResponseHelper_js_1.convertV4CollectionResponse;
    default:
      return undefined;
  }
}
function getResponseConverterV2(returnType) {
  switch (returnType) {
    case ReturnTypes.VALUE:
      return ResponseHelper_js_1.convertV2ValueResponse;
    case ReturnTypes.COMPLEX:
      return ResponseHelper_js_1.convertV2ModelResponse;
    case ReturnTypes.VALUE_COLLECTION:
    case ReturnTypes.COMPLEX_COLLECTION:
      return ResponseHelper_js_1.convertV2CollectionResponse;
    default:
      return undefined;
  }
}
class OperationReturnType {
  constructor(returnType, type = undefined) {
    this.returnType = returnType;
    this.type = type;
  }
  doConvert(response, isV2 = false) {
    const responseConverter = isV2 ? getResponseConverterV2(this.returnType) : getResponseConverter(this.returnType);
    if (!this.type || !responseConverter) {
      return response;
    }
    return responseConverter(response, this.type);
  }
  convertResponse(response) {
    return this.doConvert(response);
  }
  convertResponseV2(response) {
    return this.doConvert(response, true);
  }
}
exports.OperationReturnType = OperationReturnType;
exports.emptyOperationReturnType = new OperationReturnType(ReturnTypes.VOID);
